import { Directive } from '@angular/core';
import { InputNumber } from 'primeng/inputnumber';

/**
 * Pins every `p-inputNumber` to en-US number formatting (dot decimal, comma thousands).
 *
 * Without a `locale` input, PrimeNG's InputNumber formats AND parses with the browser/OS locale
 * (`Intl.NumberFormat(undefined)`), so on a machine set to a comma-decimal locale (e.g. Windows with
 * Spanish regional settings) an amount renders as `320,9995` — while everything else on the page goes
 * through Angular's `number` pipe on the app default LOCALE_ID (en-US) and shows `25,679.96`. Worse than
 * the cosmetic clash, a user typing `320.9995` on such a machine gets a mis-parsed value.
 *
 * Matches only inputs that don't set their own `locale`, so a deliberate per-field locale still wins.
 * The assignment lives in the constructor because InputNumber builds its Intl formatter in ngOnInit,
 * which runs after all host-directive constructors.
 */
@Directive({
  // Deliberately an element selector, not the app-prefixed attribute the lint rule expects: matching
  // the PrimeNG element is what makes this apply to every existing p-inputNumber with no per-field edit.
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'p-inputNumber:not([locale]), p-inputnumber:not([locale]), p-input-number:not([locale])',
  standalone: true,
})
export class InputNumberLocaleDirective {
  constructor(inputNumber: InputNumber) {
    inputNumber.locale = 'en-US';
  }
}
